import { render, staticRenderFns } from "./OrderHoldByReservationIframe.vue?vue&type=template&id=05ceb5de&"
import script from "./OrderHoldByReservationIframe.vue?vue&type=script&lang=ts&"
export * from "./OrderHoldByReservationIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports